(function cascadiaCartEdit(){

  var _productCache = new Map();
  var modalEl = null;
  var previouslyFocused = null;
  var currentItem = null;
  var currentProduct = null;
  var selections = [];
  var modalChangedVariant = false;

  function buildModal(){
    if (modalEl) return modalEl;

    var overlay = document.createElement('div');
    overlay.id = 'cas-edit-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'cas-edit-modal-title');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="cas-edit-modal__backdrop"></div>' +
      '<div class="cas-edit-modal__sheet">' +
        '<div class="cas-edit-modal__header">' +
          '<p id="cas-edit-modal-title" class="cas-edit-modal__title">Edit item</p>' +
          '<button type="button" class="cas-edit-modal__close" aria-label="Close">' +
            '<svg width="14" height="14" viewBox="0 0 64 64" fill="none" stroke="#3d2314" stroke-width="6" stroke-linecap="round"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="cas-edit-modal__product" id="cas-edit-modal-product"></div>' +
        '<div class="cas-edit-modal__body" id="cas-edit-modal-body"></div>' +
        '<div class="cas-edit-modal__footer">' +
          '<button type="button" class="cas-edit-modal__save" id="cas-edit-modal-save" disabled>Save changes</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    modalEl = overlay;

    // Our modal is appended to document.body, outside the cart drawer's own
    // DOM — Motion's drawer closes on any click it detects outside itself,
    // so without this, every click *inside* our modal (not just the click
    // that opens it) would register as an outside-click and close the
    // drawer behind us. Stopping propagation once here, at the modal root,
    // covers every element inside it in one place.
    overlay.addEventListener('click', function(e){ e.stopPropagation(); });

    overlay.querySelector('.cas-edit-modal__backdrop').addEventListener('click', closeModal);
    overlay.querySelector('.cas-edit-modal__close').addEventListener('click', closeModal);
    overlay.querySelector('#cas-edit-modal-save').addEventListener('click', saveChanges);

    overlay.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') trapFocus(e);
    });

    return overlay;
  }

  function trapFocus(e){
    var focusable = modalEl.querySelectorAll('button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function openModal(item){
    buildModal();
    currentItem = item;
    previouslyFocused = document.activeElement;
    modalChangedVariant = false;
    window.cascadiaTrack && window.cascadiaTrack('cart_edit_modal_opened');

    modalEl.querySelector('#cas-edit-modal-body').innerHTML = '<p class="cas-edit-modal__loading">Loading options…</p>';
    modalEl.querySelector('#cas-edit-modal-product').innerHTML = '';

    modalEl.hidden = false;
    document.body.style.setProperty('overflow', 'hidden', 'important');
    requestAnimationFrame(function(){ modalEl.classList.add('is-open'); });

    fetchProduct(item.handle).then(function(product){
      currentProduct = product;
      var currentVariant = product.variants.find(function(v){ return v.id === item.variant_id; });
      selections = currentVariant ? [currentVariant.option1, currentVariant.option2, currentVariant.option3].filter(function(v){ return v != null; }) : [];
      renderProduct(product, currentVariant);
      renderOptions(product);
      var closeBtn = modalEl.querySelector('.cas-edit-modal__close');
      if (closeBtn) closeBtn.focus();
    });
  }

  function closeModal(){
    if (!modalEl || modalEl.hidden) return;
    window.cascadiaTrack && window.cascadiaTrack('cart_edit_modal_closed', { changed_variant: modalChangedVariant });
    modalEl.classList.remove('is-open');
    document.body.style.removeProperty('overflow');
    setTimeout(function(){
      modalEl.hidden = true;
      if (previouslyFocused) previouslyFocused.focus();
    }, 200);
  }

  function fetchProduct(handle){
    if (_productCache.has(handle)) return Promise.resolve(_productCache.get(handle));
    return fetch('/products/' + handle + '?view=cart-edit-json')
      .then(function(r){ return r.json(); })
      .then(function(p){ _productCache.set(handle, p); return p; });
  }

  function moneyFormat(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  function renderProduct(product, currentVariant){
    var el = modalEl.querySelector('#cas-edit-modal-product');
    var currentLabel = currentVariant
      ? [currentVariant.option1, currentVariant.option2, currentVariant.option3]
          .filter(function(v){ return v != null; })
          .map(function(val, i){ return displayVal(product, i, val); })
          .join(', ')
      : '';
    el.innerHTML =
      '<img src="' + (product.featured_image || '') + '" alt="" class="cas-edit-modal__thumb">' +
      '<div><p class="cas-edit-modal__product-title">' + product.title + '</p>' +
      (currentLabel ? '<p class="cas-edit-modal__current">Currently: ' + currentLabel + '</p>' : '') +
      '</div>';
  }

  function optKey(i){ return 'option' + (i + 1); }

  // scent options show the metaobject's name; everything else shows as-is
  function displayVal(product, i, val){
    if (!/scent/i.test((product.options || [])[i] || '')) return val;
    var match = product.variants.find(function(v){ return v[optKey(i)] === val && v.scentName; });
    return match ? match.scentName : val;
  }

  function detectOptionType(name, values, variants){
    var n = name.toLowerCase();
    var isScent = n === 'scent' || n === 'mood' || n === 'colour' || n === 'color' || n === 'essential oil';
    var isSize = n === 'size' || n === 'volume' || n === 'weight' || n === 'pack';
    var hasColors = values.some(function(v){
      return variants.some(function(vr){ return vr.option1 === v || vr.option2 === v || vr.option3 === v; }) &&
        variants.some(function(vr){ return (vr.option1 === v || vr.option2 === v || vr.option3 === v) && vr.scentColor; });
    });
    if (isScent && hasColors) return 'scent';
    if (isSize) return 'size';
    if (values.length === 2) return 'pair';
    return 'plain';
  }

  function findVariant(sel){
    return currentProduct.variants.find(function(v){
      return sel.every(function(s, i){ return v[optKey(i)] === s; });
    });
  }

  function valueAvailable(optionIndex, value){
    var testSel = selections.slice();
    testSel[optionIndex] = value;
    return currentProduct.variants.some(function(v){
      var matches = testSel.every(function(s, i){ return s == null || v[optKey(i)] === s; });
      return matches && v.available !== false;
    });
  }

  function colorForValue(optionIndex, value){
    var match = currentProduct.variants.find(function(v){ return v[optKey(optionIndex)] === value && v.scentColor; });
    return match ? match.scentColor : '#c8b89a';
  }

  function priceForValue(optionIndex, value){
    var testSel = selections.slice();
    testSel[optionIndex] = value;
    var match = currentProduct.variants.find(function(v){
      return testSel.every(function(s, i){ return s == null || v[optKey(i)] === s; });
    });
    return match ? match.price : null;
  }

  function renderOptions(product){
    var body = modalEl.querySelector('#cas-edit-modal-body');
    body.innerHTML = '';

    var optionNames = product.options || [];

    optionNames.forEach(function(name, i){
      var values = [];
      product.variants.forEach(function(v){
        var val = v[optKey(i)];
        if (val != null && values.indexOf(val) === -1) values.push(val);
      });
      var type = detectOptionType(name, values, product.variants);

      var section = document.createElement('div');
      section.className = 'cas-edit-modal__section';
      var label = document.createElement('p');
      label.className = 'cas-edit-modal__label';
      label.textContent = name;
      section.appendChild(label);

      var row = document.createElement('div');
      row.className = 'cas-edit-modal__row cas-edit-modal__row--' + type;

      values.forEach(function(val){
        var available = valueAvailable(i, val);
        var isSelected = selections[i] === val;
        var el;

        if (type === 'scent') {
          el = document.createElement('button');
          el.type = 'button';
          el.className = 'cas-edit-modal__swatch' + (isSelected ? ' is-selected' : '') + (available ? '' : ' is-disabled');
          el.disabled = !available;
          el.innerHTML =
            '<span class="cas-edit-modal__dot" style="background:' + colorForValue(i, val) + '"></span>' +
            '<span>' + displayVal(product, i, val) + (available ? '' : ' — Sold out') + '</span>';
        } else {
          el = document.createElement('button');
          el.type = 'button';
          el.className = 'cas-edit-modal__pill' + (isSelected ? ' is-selected' : '') + (available ? '' : ' is-disabled');
          el.disabled = !available;
          var price = priceForValue(i, val);
          el.innerHTML =
            '<span>' + val + '</span>' +
            (price != null ? '<span class="cas-edit-modal__pill-price">' + moneyFormat(price) + '</span>' : '');
        }

        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', isSelected ? 'true' : 'false');

        el.addEventListener('click', function(){
          selections[i] = val;
          renderOptions(product);
          updateSaveButton();
        });

        row.appendChild(el);
      });

      section.appendChild(row);
      body.appendChild(section);
    });

    updateSaveButton();
  }

  function updateSaveButton(){
    var saveBtn = modalEl.querySelector('#cas-edit-modal-save');
    var match = findVariant(selections);

    if (!match || match.available === false) {
      saveBtn.disabled = true;
      saveBtn.textContent = 'Select a valid combination';
      return;
    }
    if (match.id === currentItem.variant_id) {
      saveBtn.disabled = true;
      saveBtn.textContent = 'Save changes';
      return;
    }
    saveBtn.disabled = false;
    saveBtn.textContent = 'Save changes — ' + moneyFormat(match.price);
  }

  function saveChanges(){
    var match = findVariant(selections);
    if (!match || match.id === currentItem.variant_id) return;

    var saveBtn = modalEl.querySelector('#cas-edit-modal-save');
    saveBtn.disabled = true;
    var originalText = saveBtn.textContent;
    saveBtn.textContent = 'Saving…';

    // Deliberately bypassing window.cascadiaState.removeFromCart/addToCart
    // here — each one auto-dispatches cascadia:cart-changed on its own,
    // and cascadia-cart.js debounces that event, so calling both back-to-back
    // causes a render to fire after the removal but before the add lands,
    // and the follow-up event gets silently swallowed by the debounce.
    // Hitting the same endpoints directly lets us dispatch exactly once,
    // after the full swap (and a fresh refresh) is genuinely complete.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentItem.key, quantity: 0 })
    })
      .then(function(){
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: match.id, quantity: currentItem.quantity, properties: currentItem.properties || {} }]
          })
        });
      })
      .then(function(){
        return window.cascadiaState.refresh();
      })
      .then(function(){
        saveBtn.textContent = 'Saved';
        modalChangedVariant = true;
        document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
        document.dispatchEvent(new Event('cart:open'));
        closeModal();
      })
      .catch(function(err){
        console.warn('[cascadia] edit save failed', err);
        saveBtn.textContent = 'Error — try again';
        saveBtn.disabled = false;
        setTimeout(function(){ saveBtn.textContent = originalText; }, 2000);
      });
  }

  if (!document.getElementById('cascadia-edit-modal-css')) {
    var st = document.createElement('style');
    st.id = 'cascadia-edit-modal-css';
    st.textContent = `
      #cas-edit-modal { position:fixed; inset:0; z-index:1000; font-family:'Jost',sans-serif; }
      #cas-edit-modal .cas-edit-modal__backdrop { position:absolute; inset:0; background:rgba(20,14,8,0.4); opacity:0; transition:opacity 0.2s ease; }
      #cas-edit-modal.is-open .cas-edit-modal__backdrop { opacity:1; }

      #cas-edit-modal .cas-edit-modal__sheet {
        position:absolute; background:#fff; display:flex; flex-direction:column;
        box-shadow:0 20px 50px rgba(0,0,0,0.15);
        left:50%; top:50%; transform:translate(-50%,-46%); opacity:0;
        width:min(420px, calc(100vw - 32px)); max-height:82vh;
        border-radius:20px; transition:opacity 0.2s ease, transform 0.2s ease;
      }
      #cas-edit-modal.is-open .cas-edit-modal__sheet { opacity:1; transform:translate(-50%,-50%); }

      @media screen and (max-width:600px) {
        #cas-edit-modal .cas-edit-modal__sheet {
          left:0; right:0; top:auto; bottom:0; transform:translateY(100%); width:100%;
          max-height:85vh; border-radius:20px 20px 0 0;
        }
        #cas-edit-modal.is-open .cas-edit-modal__sheet { transform:translateY(0); }
      }

      #cas-edit-modal .cas-edit-modal__header { display:flex; align-items:center; justify-content:space-between; padding:18px 20px; border-bottom:0.5px solid #e8e5e0; flex-shrink:0; }
      #cas-edit-modal .cas-edit-modal__title { font-family:'Cormorant Garamond',Georgia,serif; font-style:italic; font-size:18px; color:#3d2314; margin:0; }
      #cas-edit-modal .cas-edit-modal__close { width:28px; height:28px; border-radius:50%; background:#f0ece7; border:none; cursor:pointer; display:flex; align-items:center; justify-content:center; padding:0; flex-shrink:0; }

      #cas-edit-modal .cas-edit-modal__product { display:flex; align-items:center; gap:12px; padding:18px 20px 16px; border-bottom:0.5px solid #e8e5e0; flex-shrink:0; }
      #cas-edit-modal .cas-edit-modal__thumb { width:52px; height:52px; border-radius:10px; object-fit:cover; background:#f0ece7; flex-shrink:0; }
      #cas-edit-modal .cas-edit-modal__product-title { font-size:13px; font-weight:500; color:#3d2314; margin:0 0 3px; }
      #cas-edit-modal .cas-edit-modal__current { font-size:11.5px; color:#8a7e6e; margin:0; }

      #cas-edit-modal .cas-edit-modal__body { padding:16px 20px; overflow-y:auto; flex:1 1 auto; }
      #cas-edit-modal .cas-edit-modal__loading { font-size:13px; color:#8a7e6e; text-align:center; padding:20px 0; }

      #cas-edit-modal .cas-edit-modal__section + .cas-edit-modal__section { margin-top:18px; }
      #cas-edit-modal .cas-edit-modal__label { font-size:9px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:#a1917a; margin:0 0 10px; }

      #cas-edit-modal .cas-edit-modal__row { display:flex; flex-wrap:wrap; gap:8px; }

      #cas-edit-modal .cas-edit-modal__swatch {
        display:flex; align-items:center; gap:6px; border:1px solid #e8e5e0; border-radius:50px;
        padding:7px 13px 7px 8px; background:#fff; cursor:pointer; font-size:12px; color:#3d2314; font-weight:500;
      }
      #cas-edit-modal .cas-edit-modal__dot { width:16px; height:16px; border-radius:50%; flex-shrink:0; }
      #cas-edit-modal .cas-edit-modal__swatch.is-selected { border:1.5px solid #3d2314; background:#fdfaf4; font-weight:600; }
      #cas-edit-modal .cas-edit-modal__swatch.is-selected .cas-edit-modal__dot { box-shadow:0 0 0 2px #fff, 0 0 0 3px #3d2314; }
      #cas-edit-modal .cas-edit-modal__swatch.is-disabled { opacity:0.4; cursor:not-allowed; text-decoration:line-through; }

      #cas-edit-modal .cas-edit-modal__row--size,
      #cas-edit-modal .cas-edit-modal__row--pair,
      #cas-edit-modal .cas-edit-modal__row--plain { }

      #cas-edit-modal .cas-edit-modal__pill {
        flex:1; min-width:90px; text-align:center; border:1px solid #e8e5e0; border-radius:10px;
        padding:10px 8px; background:#fff; cursor:pointer; display:flex; flex-direction:column; gap:2px;
      }
      #cas-edit-modal .cas-edit-modal__pill span:first-child { font-size:12.5px; font-weight:500; color:#3d2314; }
      #cas-edit-modal .cas-edit-modal__pill-price { font-size:11px; color:#8a7e6e; }
      #cas-edit-modal .cas-edit-modal__pill.is-selected { border:1.5px solid #3d2314; background:#3d2314; }
      #cas-edit-modal .cas-edit-modal__pill.is-selected span:first-child { color:#faf8f5; font-weight:600; }
      #cas-edit-modal .cas-edit-modal__pill.is-selected .cas-edit-modal__pill-price { color:#c4bfb4; }
      #cas-edit-modal .cas-edit-modal__pill.is-disabled { opacity:0.4; cursor:not-allowed; }

      #cas-edit-modal .cas-edit-modal__footer { padding:16px 20px; border-top:0.5px solid #e8e5e0; flex-shrink:0; }
      #cas-edit-modal .cas-edit-modal__save {
        width:100%; background:#03593A; color:#fff; border:none; border-radius:999px;
        padding:13px; font-size:13px; font-weight:600; cursor:pointer; font-family:'Jost',sans-serif;
      }
      #cas-edit-modal .cas-edit-modal__save:disabled { background:#e8e5e0; color:#8a7e6e; cursor:not-allowed; }

      @media (prefers-reduced-motion: reduce) {
        #cas-edit-modal .cas-edit-modal__backdrop,
        #cas-edit-modal .cas-edit-modal__sheet { transition:none; }
      }
    `;
    document.head.appendChild(st);
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.cas-edit-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var key = btn.dataset.key;
    var liveCart = window.cascadiaState && window.cascadiaState.peek();
    var item = liveCart && liveCart.items.find(function(i){ return i.key === key; });
    if (!item) return;
    openModal(item);
  });

  console.log('[cascadia] edit modal ready');

})();